import * as yup from 'yup';
import { error } from '../text';

const numberTrim = (
  value: string | number | null | undefined,
  originalValue: string | number | null | undefined,
): number | null => {
  if (typeof originalValue === 'string') {
    return originalValue.trim() === '' ? null : Number(value);
  }
  if (value == null) {
    return null;
  }
  return Number(value);
};
const clientIdValidation = yup.string().nullable();
const clientNameValidation = yup.string().required(error.required).max(250, error.below250);

const postalCodeValidation = yup
  .string()
  .nullable()
  .when({
    is: (value: string | null | undefined) => value && value.trim().length > 0,
    then: schema =>
      schema.matches(/^[0-9]{3}-[0-9]{4}$/, `ハイフンを含めて郵便番号の形式で入力してください`),
  });

const addressValidation = yup.string().nullable().max(250, error.below250);

const invoiceNumberValidation = yup.string().nullable().max(250, error.below250);

const invoiceDateValidation = yup.date().nullable().typeError(error.date);

const totalAmountValidation = yup
  .number()
  .transform((value, originalValue) => numberTrim(value, originalValue))
  .typeError(error.number)
  .required(error.required);

const productNameValidation = yup.string().nullable().max(250, error.below250);

const productIdValidation = yup.string().nullable();

const quantityValidation = yup
  .number()
  .transform((value, originalValue) => numberTrim(value, originalValue))
  .typeError(error.number)
  .nullable();

const unitPriceValidation = yup
  .number()
  .transform((value, originalValue) => numberTrim(value, originalValue))
  .typeError(error.number)
  .nullable();

const mountValidation = yup
  .number()
  .transform((value, originalValue) => numberTrim(value, originalValue))
  .typeError(error.number)
  .nullable();

const remarksValidation = yup.string().nullable().max(250, error.below250);

const productUnmatchFlgValidation = yup.boolean().nullable();

export const aiOcrResultMainInfoSchema = yup.object().shape({
  clientId: clientIdValidation,
  clientName: clientNameValidation,
  postCode: postalCodeValidation,
  address: addressValidation,
  invoiceNumber: invoiceNumberValidation,
  invoiceDate: invoiceDateValidation,
  totalAmount: totalAmountValidation,
  clientUnmatchFlg: yup.boolean().nullable(),
  searchUnmatchFlg: yup.boolean().nullable(),
  list: yup
    .array()
    .of(
      yup
        .object()
        .shape({
          productName: productNameValidation,
          productId: productIdValidation,
          quantity: quantityValidation,
          unitPrice: unitPriceValidation,
          amount: mountValidation,
          remarks: remarksValidation,
          productUnmatchFlg: productUnmatchFlgValidation,
        })
        .nullable(),
    )
    .nullable(),
});
